
import '../Services.css';
import img from '../../../assets/hero-home-image2.png'; // Construction/Hero image
import PropertyAdvantage from '../../../components/PropertyAdvantage/PropertyAdvantage';
import ConversationSection from '../../../components/ConversationSection/ConversationSection';

const ConstructionDevelopment = () => {
    return (
        <div className="service-page">
            <div className="service-hero">
                <h1>Construction & Development</h1>
            </div>
            <section className="service-split-section">
                <div className="service-split-container">
                    <div className="service-left">
                        <span className="service-badge-pill">Success, Together</span>
                        <h2 className="service-split-title">Construction & Development</h2>
                        <p className="service-split-text">
                            At Jeevan Realty, we simplify every aspect of construction and development—turning your vision into reality. From architectural planning to the final brick, our comprehensive services ensure quality, transparency, and timely delivery of your dream project.
                        </p>
                    </div>
                    <div className="service-right">
                        <img src={img} alt="Construction Development" />
                    </div>
                </div>
            </section>

            <div className="service-steps-container">
                <div className="service-steps-list">
                    {/* Step 1 */}
                    <div className="service-step-card">
                        <div className="service-step-number">1</div>
                        <div className="service-step-content">
                            <h3>Concept & Planning</h3>
                            <p>We work with you to conceptualize your dream project, defining the scope, budget, and timeline.</p>
                        </div>
                    </div>

                    {/* Step 2 */}
                    <div className="service-step-card">
                        <div className="service-step-number">2</div>
                        <div className="service-step-content">
                            <h3>Architectural Design</h3>
                            <p>Our architects create detailed blueprints and 3D models, ensuring functionality and aesthetic appeal.</p>
                        </div>
                    </div>

                    {/* Step 3 */}
                    <div className="service-step-card">
                        <div className="service-step-number">3</div>
                        <div className="service-step-content">
                            <h3>Approvals & Permits</h3>
                            <p>We handle all liaison work with local authorities to obtain necessary building permits and clearances.</p>
                        </div>
                    </div>

                    {/* Step 4 */}
                    <div className="service-step-card">
                        <div className="service-step-number">4</div>
                        <div className="service-step-content">
                            <h3>Construction</h3>
                            <p>Our skilled team executes the construction with precision, using quality materials and adhering to safety standards.</p>
                        </div>
                    </div>

                    {/* Step 5 */}
                    <div className="service-step-card">
                        <div className="service-step-number">5</div>
                        <div className="service-step-content">
                            <h3>Quality Checks</h3>
                            <p>Regular inspections and quality control measures are implemented at every stage to ensure excellence.</p>
                        </div>
                    </div>

                    {/* Step 6 */}
                    <div className="service-step-card">
                        <div className="service-step-number">6</div>
                        <div className="service-step-content">
                            <h3>Handover</h3>
                            <p>We deliver the completed project on time, ensuring every detail meets your expectations before final handover.</p>
                        </div>
                    </div>
                </div>
            </div>

            <PropertyAdvantage />
            <ConversationSection />
        </div >
    );
};

export default ConstructionDevelopment;
